/**
 * Accordion
 */

export default (() => {
  const accordions = document.querySelectorAll('.accordion')

  const openAccordion = (accordion) => {
    const content = accordion.querySelector('.accordion-content')
    accordion.classList.add('accordion-active')
    content.style.maxHeight = content.scrollHeight + 'px'
  }

  const closeAccordion = (accordion) => {
    const content = accordion.querySelector('.accordion-content')
    accordion.classList.remove('accordion-active')
    content.style.maxHeight = null
  }

  accordions.forEach((accordion) => {
    if (accordion.classList.contains('accordion-active')) {
      openAccordion(accordion)
    }
  })

  accordions.forEach((accordion) => {
    const heading = accordion.querySelector('.accordion-heading')
    const content = accordion.querySelector('.accordion-content')

    heading.onclick = () => {
      if (content.style.maxHeight) {
        closeAccordion(accordion)
      } else {
        accordions.forEach((accordion) => closeAccordion(accordion))
        openAccordion(accordion)
      }
    }
  })
})()
